import { BaseSliceController } from '@Base/slices/slices.base';
import { InstructorCodesRequester } from '../Services/InstructorCodes.req';
import { InstructorCode } from '../Types/InstructorCodes.types';

export class InstructorCodesSlice extends BaseSliceController<
	InstructorCode,
	'InstructorCodes'
> {
	private static instance: InstructorCodesSlice;
	static getInstance() {
		if (!InstructorCodesSlice.instance) {
			InstructorCodesSlice.instance = new InstructorCodesSlice();
		}
		return InstructorCodesSlice.instance;
	}
	constructor() {
		super('InstructorCodes', InstructorCodesRequester.getInstance());
	}
}

export const {
	instructorCodesDeleteById,
	instructorCodesExportData,
	instructorCodesGenerate,
	instructorCodesGetAll,
} = InstructorCodesSlice.getInstance().getActions();
